import { TaskLink } from '@api';
import { JiraIconGray } from '@icons';
import React from 'react';
import { useClassNames } from '../../../../common/hooks';
import './TaskLinkComp.scss';

interface TaskLinkCompProps {
    taskLink: TaskLink,
    className?: string,
}

function TaskLinkComp(props: TaskLinkCompProps): JSX.Element {
    const {
        taskLink,
        className,
    } = props;

    let linkText = "";
    let linkTitle = "";
    let linkIcon: JSX.Element = null;

    switch (taskLink.kind) {
        case "Jira":
            linkIcon = <JiraIconGray className='task-link__icon' />
            break;
    }
    
    const uriParts = taskLink.uri.split('/');

    switch (taskLink.kind) {
        case "Jira":
            linkText = `${uriParts[uriParts.length-1]}`;
            linkTitle = `Задача в ${taskLink.kind}`;
            break;

        default:
            linkText = `Задача в ${taskLink.kind}`;
            linkTitle = linkText;
    }

    const classes = useClassNames(
        'task-link',
        className,
    )

    return <a href={taskLink.uri} target="_blank" title={linkTitle} className={classes} onClick={(e) => e.stopPropagation()}>{linkIcon}{linkText}</a>
}

export {TaskLinkComp}